import React from 'react';
import { Button, getClassNameFactory, getRehydratableName } from '@dcl/ui';
import { propsToDataAttributes } from '@tr-digital/react-rehydrate';
import { IEmailArticleProps } from './types';
import { constant } from './constants';
import { triggerAnalyticsEvent } from '../../utils/analytics';
import EmailArticleIcon from './EmailArticleIcon';
import {
  ButtonColor,
  ButtonKind,
  IconPosition,
} from '@dcl/ui/dist/elements/Button';
import './index.css';

export const EmailArticle: React.FC<IEmailArticleProps> = (props) => {
  const { title, emailArticleButtonName } = props;
  const modifiedTitle = encodeURIComponent(title);
  const articleUrl = encodeURIComponent(window.location.href);
  const hrefTextForEmailArticleLink = `mailto:?subject=${modifiedTitle}&body=${modifiedTitle} ${articleUrl}`;

  const onClickEmailAnalyticsHandler = () => {
    const newWindow = window.open(
      hrefTextForEmailArticleLink,
      '_self',
      'noopener,noreferrer'
    );
    newWindow?.focus();
    triggerAnalyticsEvent(constant.trackingMessage);
  };

  const getClassName = getClassNameFactory(EmailArticle.displayName);

  return (
    <div
      data-rehydratable={getRehydratableName(EmailArticle.displayName)}
      {...propsToDataAttributes(props)}
      className={getClassName()}
    >
      <span className={getClassName({ descendantName: 'buttonBlock' })}>
        <Button
          kind={ButtonKind.BUTTON}
          color={ButtonColor.SECONDARY}
          onClick={onClickEmailAnalyticsHandler}
          data-testid="emailLink"
          iconPosition={IconPosition.LEFT}
          icon={<EmailArticleIcon />}
          newWindow={false}
        >
          {emailArticleButtonName}
        </Button>
      </span>
    </div>
  );
};

EmailArticle.displayName = 'EmailArticle';
